/* eslint-disable react/jsx-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
// components
import { Grid, Button } from '@design-system-coopeuch/web';
import CardBase from 'ui-cardbase';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';
import InputCodeSMS from '../../molecules/InputCodeSMS/InputCodeSMS';
import SkeletonInputCodeSMS from '../../molecules/SkeletonInputCodeSMS/SkeletonInputCodeSMS';
import GeneralMessage from '../../molecules/GeneralMessage/GeneralMessage';

// assets
import { StyledWrapperSms } from './styles';

const CardElectronicSignature = (props) => {
  const {
    inputCodeSMS,
    phone,
    stateAuthSms,
    messagesInputAuthSms,
    disabled, // COMMENT: Este disabled conrresponde al card, que se habl¡lirá o no dependiendo del check termnsAndContitions
    onChange,
    onInvokeAuthSms,
    onTimeOverToRespond,
  } = props;

  return (
    <SimpleCard
      contentHeader={<p className="simplecard__title">Firma electrónica</p>}
      disabled={disabled}
    >
      <Grid className="m-0 padding-16 p-md-6">
        <Grid className="p-0">
          <p className="px-0 mb-2">
            Al ingresar el siguiente método de autorización y hacer tu primera inversión de cuotas
            de participación, serás Socio Coopeuch.
          </p>
        </Grid>
        <StyledWrapperSms row>
          <CardBase title="Mensaje de Texto SMS" sizeTitle noPadding>
            <Grid className="p-4">
              <Grid className="px-0 mb-2">
                <p className="">
                  Tu código será enviado al celular
                  <span className="text-primary-20 font-weight-bold text-color-red-coopeuch">
                    {phone ? ` +56${phone.slice(0, 1)}****${phone.slice(-4)}.` : ' +56*********'}
                  </span>
                </p>
              </Grid>
              {stateAuthSms.step === 'initial' && (
                <Grid className="p-0 py-md-4 px-md-2 d-flex justify-content-start align-items-center">
                  <Button
                    variant="default"
                    color="secondary"
                    onClick={onInvokeAuthSms}
                    className="rounded-pill text-center w-100 justify-content-center font-size-14"
                  >
                    Enviar código por SMS
                  </Button>
                </Grid>
              )}
              {stateAuthSms.step === 'loading' && <SkeletonInputCodeSMS device="mobile" />}
              {stateAuthSms.step === 'input' && (
                <>
                  <Grid row className="d-flex align-items-center">
                    <h3 className="mb-1">Código SMS</h3>
                  </Grid>
                  <Grid row className="p-0">
                    <InputCodeSMS
                      values={inputCodeSMS.value}
                      disabled={inputCodeSMS.disabled}
                      secondsAvailableToRespond={
                        /* stateAuthSms.case === 'incorretCode' || */
                        stateAuthSms.case === 'locked' || stateAuthSms.case === 'retry'
                          ? -1
                          : inputCodeSMS.secondsAvailableToRespond
                      }
                      objectMessage={messagesInputAuthSms[stateAuthSms.case]}
                      onChange={(smsCode) =>
                        onChange({
                          field: 'inputCodeSMS',
                          property: 'value',
                          value: smsCode,
                        })
                      }
                      onTimeOverToRespond={onTimeOverToRespond}
                      onInvokeAuthSms={onInvokeAuthSms}
                    />
                  </Grid>
                  {stateAuthSms.case === 'locked' && (
                    <Grid className="p-0">
                      <GeneralMessage
                        size="small"
                        type="error"
                        alignIcon="left"
                        iconVisibility
                        bgOpacity={false}
                      >
                        <p className="p-0 pl-2 text-size-18 text-color-error">
                          <strong>Has excedido el límite de intentos.</strong>
                          <br />
                          La validación con codigo SMS se encuentra bloqueada. Por favor vuelve a
                          intentarlo dentro de 24hrs.
                        </p>
                      </GeneralMessage>
                    </Grid>
                  )}
                </>
              )}
            </Grid>
          </CardBase>
        </StyledWrapperSms>
      </Grid>
    </SimpleCard>
  );
};

CardElectronicSignature.defaultProps = {
  inputCodeSMS: {
    isValid: () => null,
    errors: [],
    value: [],
    secondsAvailableToRespond: 0,
    disabled: false,
  },
  phone: '',
  stateAuthSms: {},
  messagesInputAuthSms: {},
  disabled: false,
  onTimeOverToRespond: () => null,
  onChange: () => null,
  onInvokeAuthSms: () => null,
};

CardElectronicSignature.propTypes = {
  inputCodeSMS: PropTypes.shape({
    isValid: PropTypes.func,
    errors: PropTypes.arrayOf(PropTypes.shape({ text: PropTypes.string, type: PropTypes.string })),
    value: PropTypes.arrayOf(PropTypes.string),
    secondsAvailableToRespond: PropTypes.number,
    disabled: PropTypes.bool,
  }),
  phone: PropTypes.string,
  stateAuthSms: PropTypes.shape({
    step: PropTypes.string,
    case: PropTypes.string,
  }),
  messagesInputAuthSms: PropTypes.shape({}),
  disabled: PropTypes.bool,
  onTimeOverToRespond: PropTypes.func,
  onChange: PropTypes.func,
  onInvokeAuthSms: PropTypes.func,
};

export default CardElectronicSignature;
